import React from 'react';
import { Subhead } from '@xo-union/tk-ui-typography';
import { ActionItem } from '../../gs-component-form';
import { get } from 'lodash';
import { GuestWedding } from '../GuestWeddingTypes';
import QuestionModule from './QuestionModule';
import NoQuestionsModule from './NoQuestionsModule';
import { Question, EventType } from '../EventTypes';
import styles from './eventModule.scss';
import { emptyQuestion } from '../helpers/question';
import { track } from '../helpers/analytics';

interface Props {
  guestWedding: GuestWedding;
  openQuestionRail: (question: Question | null, event: EventType | null) => void;
}

const GeneralQuestionModule: React.FC<Props> = ({ guestWedding, openQuestionRail }: Props) => {
  let questions;
  if (!guestWedding.questions || guestWedding.questions.length === 0) {
    questions = (
      <NoQuestionsModule
        testId="generalQuestion"
        event={null}
        privateRsvp={guestWedding.isPrivateRsvp}
        openQuestionRightRail={openQuestionRail}
        isRsvpRequired
      />
    );
  } else {
    questions = (
      <>
        {guestWedding.questions.map(q => {
          return (
            <QuestionModule
              key={`general-question-${q.id}`}
              question={q}
              editQuestion={(): void => openQuestionRail(q, null)}
              isGeneralQuestion
            />
          );
        })}
        <div className={styles.addQuestionContainer}>
          <ActionItem
            type="add"
            onClick={(): void => {
              track('RSVP Settings Interaction', {
                selection: 'add another question initiated',
                isGeneralQuestion: true,
              });
              openQuestionRail(emptyQuestion, null);
            }}
          >
            Add Another Question
          </ActionItem>
        </div>
      </>
    );
  }

  return (
    <div data-testid="generalQuestionsModule" className={styles.generalModuleContainer}>
      <div className={styles.eventTitleContainer}>
        <Subhead>
          <strong>General Questions</strong>
        </Subhead>
      </div>
      {get(guestWedding, ['questions', 'length']) ? (
        <span className={styles.guestDescription}>
          These questions will be asked of all guests that RSVP, regardless of if they say &apos;Yes&apos; or
          &apos;No&apos;
        </span>
      ) : null}
      {questions}
    </div>
  );
};

export default GeneralQuestionModule;
